"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleFeaturesDto = exports.ShopFeature = exports.SfProduct = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const SfProductType_1 = require("../Type/SfProductType");
class SfProduct {
}
exports.SfProduct = SfProduct;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], SfProduct.prototype, "skelloProduct", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEnum)(SfProductType_1.SfProductType),
    __metadata("design:type", String)
], SfProduct.prototype, "type", void 0);
class ShopFeature {
}
exports.ShopFeature = ShopFeature;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ShopFeature.prototype, "skShopId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SfProduct),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ShopFeature.prototype, "skProductToDisable", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => SfProduct),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ShopFeature.prototype, "skProductToEnable", void 0);
class ToggleFeaturesDto {
}
exports.ToggleFeaturesDto = ToggleFeaturesDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ToggleFeaturesDto.prototype, "organisationId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => ShopFeature),
    __metadata("design:type", Array)
], ToggleFeaturesDto.prototype, "shops", void 0);
//# sourceMappingURL=ToggleFeaturesDto.js.map